<div class='admin'>
  <app-beheer-nav></app-beheer-nav>

  <p>
    adm-profile works!
  </p>
  
</div>